export default {
  placeholder: {
    en: 'How old are you?',
  },
}
